/**
 * Draw a clear copy label after the page image so it is never covered.
 * @param {import('jspdf').jsPDF} pdf
 * @param {number} copyIndex 1-based
 * @param {number} copiesTotal
 * @param {{
 *   bounds?: { left: number, top: number, width: number, height: number },
 *   inset?: number,
 *   placement?: 'bottom-right'|'bottom-center'
 * }} [options]
 */
export function drawPdfCopyBadge(pdf, copyIndex, copiesTotal, options = {}) {
  const total = Math.max(1, Number(copiesTotal) || 1);
  const idx = Math.max(1, Number(copyIndex) || 1);
  if (total <= 1) return;

  const label = `${idx}/${total}`;
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();
  const pad = 10;
  const fontSize = 14;
  pdf.setFont('helvetica', 'bold');
  pdf.setFontSize(fontSize);
  const textW = pdf.getTextWidth(label);
  const boxW = textW + 12;
  const boxH = fontSize + 8;
  const bounds = options.bounds;
  const inset = Number.isFinite(Number(options.inset)) ? Number(options.inset) : pad;
  const x = bounds
    ? options.placement === 'bottom-center'
      ? bounds.left + (bounds.width - boxW) / 2
      : bounds.left + bounds.width - inset - boxW
    : pageW - pad - boxW;
  const y = bounds
    ? bounds.top + bounds.height - inset - boxH
    : pageH - pad - boxH;

  pdf.setFillColor(255, 255, 255);
  pdf.setDrawColor(0, 0, 0);
  pdf.setLineWidth(0.6);
  pdf.rect(x, y, boxW, boxH, 'FD');
  pdf.setTextColor(0, 0, 0);
  pdf.text(label, x + boxW / 2, y + boxH / 2 + fontSize / 3 - 1, { align: 'center' });
}
